
import "/app/src/modules/zy-crm/components/customer-edit-modal/company-enrichment-toolbar.module.less?modules";
export default {"field": `field-GR5C8y2w`,"value": `value-BuM_0_Dw`,"root": `root-gGNPqWYo`,"list": `list-gUClRlxs`,"row": `row-0Y2CP095`}
